import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { ReactHookFormCheckboxField } from '@components/ui'

import messages from '../messages'
import { CheckboxLabelSpan } from '../styles'

const StyledReactHookFormCheckboxField = styled(ReactHookFormCheckboxField)`
  margin: 0;

  label {
    margin: 0;
    align-items: center;
    border-radius: 6px;
    padding: 8px 12px 8px 8px;
    background-color: ${({ theme }) => theme.colors.primary[10]};
  }
`

const IsAutokasszaCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export function IsAutokasszaCheckbox() {
  const { formatMessage } = useIntl()

  return (
    <IsAutokasszaCheckboxWrapper>
      <StyledReactHookFormCheckboxField
        label={<CheckboxLabelSpan>{formatMessage(messages.autoCashRegisterLabel)}</CheckboxLabelSpan>}
        name="is_autokassza"
      />
    </IsAutokasszaCheckboxWrapper>
  )
}
